import { Component, inject, ViewChild } from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterOutlet,
  type Event,
} from '@angular/router';
import { TitleService } from '@core/services/title.service';
import {
  NgProgressComponent,
  NgProgressModule,
  type NgProgressRef,
} from 'ngx-progressbar';
import { TranslateService } from '@ngx-translate/core';
import { HelperService } from '@core/helper/helper.service';
import { AuthenticationService } from '@core/services/auth.service';
import { Store } from '@ngrx/store';
import { EmployeeActions } from '@/store/employee/employee.actions';
import { getUserProfile } from '@/store/employee/employee.selectors';
import { getisLoggedIn } from '@/store/authentication/authentication.selector';
import { loginSuccess } from '@/store/authentication/authentication.actions';
import { LoaderComponent } from '@components/loader/loader.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NgProgressModule, LoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'OneApp';
  private titleService = inject(TitleService);
  private helperService = inject(HelperService);
  private authService = inject(AuthenticationService);
  progressRef!: NgProgressRef;
  @ViewChild(NgProgressComponent) progressBar!: NgProgressComponent;

  private router = inject(Router);
  private translate = inject(TranslateService);
  private store = inject(Store);

  constructor() {
    this.router.events.subscribe((event: Event) => {
      this.checkRouteChange(event);
    });
    this.translate.addLangs(['en']);
    this.translate.setDefaultLang('en');
    this.translate.use('en');
  }

  ngOnInit(): void {
    this.titleService.init();
    if (this.authService.session) {
      this.store.dispatch(
        loginSuccess({
          user: {
            token: this.authService.session,
          },
        })
      );
    }
  }

  checkRouteChange(routerEvent: Event) {
    if (routerEvent instanceof NavigationStart) {
      this.progressBar.start();
    }
    if (
      routerEvent instanceof NavigationEnd ||
      routerEvent instanceof NavigationCancel ||
      routerEvent instanceof NavigationError
    ) {
      setTimeout(() => {
        this.progressBar.complete();
      }, 200);
    }
  }
}
